import { toast } from '../../features/toast'
import { IStoreState } from '../../reducers/types'
import { ICommonApi } from '../../api'
import { Observable } from 'rxjs'
import { ENDPOINT } from '../../constants'

export const kvitteringFerdigstillFailedToast = toast.actions.showToast({
  text: 'Kunne ikke ferdigstille tilsyn',
  timeoutSeconds: 3,
  dismissible: true,
  type: 'DANGER',
})

export const fetchKvitteringById$ =
  (commonApi: ICommonApi, state: IStoreState) =>
  (id) =>
  (obs$: Observable<any>) => {
    return obs$.pipe(
      commonApi.get(
        `${ENDPOINT.TILSYNSKVITTERING}/tilsynskvitteringer/${id}?expand=tilsynsobjekter,kontrollpunkter,observasjoner,bildeIds,veiledninger`,
        state
      )
    )
  }
